export var Role;
(function (Role) {
  Role.SUPER_ADMIN = 'SUPER_ADMIN';
  Role.ORG_SUPER_ADMIN = 'ORG_SUPER_ADMIN';
  Role.ORG_ADMIN = 'ORG_ADMIN';
  Role.STAFF = 'STAFF';
  Role.USER = 'USER';
  Role.USER_VIEW = 'USER_VIEW';
  Role.CHANNEL_VIEW = 'CHANNEL_VIEW';
  Role.WALLET_TRANSACTION_VIEW = 'WALLET_TRANSACTION_VIEW';
  Role.INCOME_VIEW = 'INCOME_VIEW';
  Role.VIDEO_VIEW = 'VIDEO_VIEW';
  Role.USER_EDIT = 'USER_EDIT';
  Role.CHANNEL_EDIT = 'CHANNEL_EDIT';
  Role.WALLET_TRANSACTION_EDIT = 'WALLET_TRANSACTION_EDIT';
  Role.INCOME_EDIT = 'INCOME_EDIT';
  Role.VIDEO_EDIT = 'VIDEO_EDIT';
  Role.USER_DELETE = 'USER_DELETE';
  Role.CHANNEL_DELETE = 'CHANNEL_DELETE';
  Role.WALLET_TRANSACTION_DELETE = 'WALLET_TRANSACTION_DELETE';
  Role.INCOME_DELETE = 'INCOME_DELETE';
  Role.VIDEO_DELETE = 'VIDEO_DELETE';
  Role.FINANCIAL_MANAGEMENT = 'FINANCIAL_MANAGEMENT';
  Role.FINANCIAL_EDIT = 'FINANCIAL_EDIT';
  Role.CHANNEL_CREATE = 'CHANNEL_CREATE';
  Role.WALLET_TRANSACTION_CREATE = 'WALLET_TRANSACTION_CREATE';
  Role.INCOME_CREATE = 'INCOME_CREATE';
  Role.VIDEO_CREATE = 'VIDEO_CREATE';
  Role.USER_CREATE = 'USER_CREATE';
  Role.SEND_SMS = 'SEND_SMS';
}(Role || (Role = {})));
export const RoleTree = {
  [Role.SUPER_ADMIN]: [
    Role.ORG_SUPER_ADMIN,
  ],
  [Role.ORG_SUPER_ADMIN]: [
    Role.ORG_ADMIN,
    Role.FINANCIAL_MANAGEMENT,
  ],
  [Role.ORG_ADMIN]: [
    Role.USER_EDIT,
    Role.WALLET_TRANSACTION_EDIT,
    Role.INCOME_EDIT,
    Role.VIDEO_EDIT,
    Role.CHANNEL_EDIT,
    Role.WALLET_TRANSACTION_CREATE,
    Role.INCOME_CREATE,
    Role.USER_CREATE,
    Role.VIDEO_CREATE,
    Role.CHANNEL_CREATE,
    Role.VIDEO_DELETE,
    Role.CHANNEL_DELETE,
    Role.STAFF,
    Role.SEND_SMS,
  ],
  [Role.USER_EDIT]: [Role.USER_VIEW],
  [Role.INCOME_EDIT]: [Role.INCOME_VIEW],
  [Role.CHANNEL_EDIT]: [Role.CHANNEL_VIEW],
  [Role.VIDEO_EDIT]: [Role.VIDEO_VIEW],
  [Role.WALLET_TRANSACTION_EDIT]: [Role.WALLET_TRANSACTION_VIEW],
  [Role.USER_DELETE]: [Role.USER_VIEW],
  [Role.INCOME_DELETE]: [Role.INCOME_VIEW],
  [Role.CHANNEL_DELETE]: [Role.CHANNEL_VIEW],
  [Role.VIDEO_DELETE]: [Role.VIDEO_VIEW],
  [Role.WALLET_TRANSACTION_DELETE]: [Role.WALLET_TRANSACTION_VIEW],
  [Role.INCOME_CREATE]: [Role.INCOME_VIEW],
  [Role.CHANNEL_CREATE]: [Role.CHANNEL_VIEW],
  [Role.VIDEO_CREATE]: [Role.VIDEO_VIEW],
  [Role.WALLET_TRANSACTION_CREATE]: [Role.WALLET_TRANSACTION_VIEW],
  [Role.FINANCIAL_MANAGEMENT]: [
    Role.FINANCIAL_EDIT,
    Role.WALLET_TRANSACTION_EDIT,
    Role.WALLET_TRANSACTION_CREATE,
    Role.INCOME_EDIT,
    Role.INCOME_CREATE,
  ],
};
export default Role;
